import { Link } from "react-router-dom";

export default function Button() {
  return (
    <Link className="header-button pointer transition fs-200" to="/contact">
      Contact Us
    </Link>
  );
}
